const keyFor = (uid, base) => `u:${uid}:${base}`;
export function loadSessions(uid) {
    try {
        const raw = localStorage.getItem(keyFor(uid, 'sessions'));
        return raw ? JSON.parse(raw) : [];
    }
    catch {
        return [];
    }
}
export function saveSessions(uid, sessions) {
    try {
        localStorage.setItem(keyFor(uid, 'sessions'), JSON.stringify(sessions));
    }
    catch { }
}
export function loadMineGames(uid) {
    try {
        const raw = localStorage.getItem(keyFor(uid, 'mine_games'));
        return raw ? JSON.parse(raw) : [];
    }
    catch {
        return [];
    }
}
export function saveMineGames(uid, mine) {
    try {
        localStorage.setItem(keyFor(uid, 'mine_games'), JSON.stringify(mine));
    }
    catch { }
}
export function loadRecentSessionIds(uid) {
    try {
        const raw = localStorage.getItem(keyFor(uid, 'recent_sessions'));
        return raw ? JSON.parse(raw) : [];
    }
    catch {
        return [];
    }
}
export function saveRecentSessionIds(uid, ids) {
    try {
        localStorage.setItem(keyFor(uid, 'recent_sessions'), JSON.stringify(ids));
    }
    catch { }
}
export function clearUserNamespace(uid) {
    try {
        localStorage.removeItem(keyFor(uid, 'sessions'));
        localStorage.removeItem(keyFor(uid, 'mine_games'));
        localStorage.removeItem(keyFor(uid, 'recent_sessions'));
    }
    catch { }
}
